import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import CircularProgress from '@material-ui/core/CircularProgress';
import PhoneInTalkOutlinedIcon from '@material-ui/icons/PhoneInTalkOutlined';
import api from '../services/api';
import ContatoRapido from './ContatoRapido';

/**
 * Botão "Contatos" que busca o lead sob demanda (GET lead/{id}) e mostra
 * telefone da empresa + decisores com ações de um clique.
 * Usado no card do board e na tela Meus leads de hoje, onde a listagem não traz os telefones.
 */
export default function ContatosLead({ leadId, mailingLeadsId, rotulo = 'Contatos' }) {
    const [ancora, setAncora] = useState(null);
    const [lead, setLead] = useState(null);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState(false);

    const abrir = async (evento) => {
        evento.stopPropagation();
        setAncora(evento.currentTarget);
        if (lead || carregando) return;
        setCarregando(true);
        setErro(false);
        try {
            const query = mailingLeadsId ? `?mailing_leads_id=${encodeURIComponent(mailingLeadsId)}` : '';
            const { data } = await api.get(`lead/${leadId}${query}`);
            setLead(data);
        } catch (e) {
            setErro(true);
        } finally {
            setCarregando(false);
        }
    };

    const decisores = (lead?.responsible || []).filter((r) => r && (r.name || r.telephone || r.email || r.linkedin));

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                style={{ color: '#2F6420', borderColor: '#B8D3AC', textTransform: 'none' }}
                startIcon={<PhoneInTalkOutlinedIcon fontSize="small" />}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={abrir}
                data-testid="abrir-contatos"
            >
                {rotulo}
            </Button>
            <Popover
                open={!!ancora}
                anchorEl={ancora}
                onClose={() => setAncora(null)}
                onClick={(e) => e.stopPropagation()}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                <div style={{ padding: 12, minWidth: 280, maxWidth: 360, fontSize: 14 }} data-testid="popover-contatos">
                    {carregando && <div style={{ textAlign: 'center', padding: 8 }}><CircularProgress size={20} /></div>}
                    {erro && <div style={{ color: '#8E2F12' }}>Não foi possível carregar os contatos.</div>}
                    {lead && (
                        <>
                            <div style={{ fontWeight: 600, marginBottom: 4 }}>{lead.corporate_name}</div>
                            {lead.telephone ? (
                                <div style={{ marginBottom: 8 }}>
                                    <div style={{ fontSize: 12, color: '#666' }}>Empresa</div>
                                    <ContatoRapido telefone={lead.telephone} />
                                </div>
                            ) : (
                                <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>Empresa sem telefone cadastrado.</div>
                            )}
                            {decisores.length === 0 && (
                                <div style={{ fontSize: 12, color: '#666' }}>Nenhum decisor cadastrado.</div>
                            )}
                            {decisores.map((r, i) => (
                                <div key={r.id || i} style={{ borderTop: '1px solid #eee', paddingTop: 6, marginTop: 6 }}>
                                    <div style={{ fontWeight: 500 }}>{r.name}{r.cargo ? <span style={{ color: '#666', fontWeight: 400 }}> · {r.cargo}</span> : null}</div>
                                    <ContatoRapido telefone={r.telephone} email={r.email} linkedin={r.linkedin} />
                                </div>
                            ))}
                        </>
                    )}
                </div>
            </Popover>
        </>
    );
}
